<div class="content">
  <div class="button-left" *ngIf="hasLeftAction">
    <ng-content select="rt-icon-button.button-left"></ng-content>
  </div>

  <rt-heading [class.uppercased]="uppercase" #heading>
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </rt-heading>

  <ng-template #content>
    <ng-content></ng-content>
  </ng-template>

  <div class="button-right" *ngIf="hasRightAction">
    <ng-content select="rt-icon-button.button-right,"></ng-content>
  </div>
</div>

<div class="search">
  <ng-content select="rt-form-field"></ng-content>
</div>

<rt-divider *ngIf="!search && hasDivider"></rt-divider>
